// extracted by mini-css-extract-plugin
module.exports = {"uploadWrap":"index_uploadWrap-3p31V"};